import { render, staticRenderFns } from "./select-target-language.vue?vue&type=template&id=b7d1419a&scoped=true&"
import script from "./select-target-language.vue?vue&type=script&lang=js&"
export * from "./select-target-language.vue?vue&type=script&lang=js&"
import style0 from "./select-target-language.vue?vue&type=style&index=0&id=b7d1419a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d1419a",
  null
  
)

export default component.exports